<div class="desktop-section">
  <!-- Conteúdo que deve aparecer apenas em desktop -->
  <!-- <app-not-found></app-not-found> -->
  <div class="container-iris">
    <div class="row align-items-center">
      <div class="col-md-6" style="border: 8px solid #165079; border-image-slice: 6; border-radius: 94px !important">
        <img
          src="../../../../../assets/app-assets/images/ilustracao/iris-geia-polo.png"
          alt="Imagem"
          class="img-fluid" />
      </div>
      <div class="col-md-6">
        <div class="desktop-message">
          <h1 class="typing-text">Página de Seguros</h1>
          <p class="typing-text">Por favor, acesse esta página em um dispositivo móvel.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mobile-tablet-section">
  <header class="template-header sticky-header header-two">
    <div class="container-fluid">
      <div
        class="header-navigation box-shadow-5 header-style   {{ verificarEstiloPortal() }}"
        style="padding: 0; display: flex; justify-content: center">
        <div class="header-left">
          <div class="site-logo">
            <a [routerLink]="'/home'" (click)="navigateToSection('home')">
              <div class="figure">
                <img class="img-geia-top image-main" src="../../../../assets/app-assets/images/logo/logo-b-geia.png" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="feature-medicine-section mt-3" style="background-color: #fff !important">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12">
          <div class="section-heading heading-white full-width-text full-width-text-title">
            <div class="section-heading mt-5">
              <span class="subt-title-left span-30px title-geia-seguros">
                <i class="title-left">Géia</i>
                Seguros
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Carrossel -->
      <div id="carouselExampleControls" class="carousel slide block" data-ride="carousel" data-interval="3000">
        <section
          class="banner-container fale-consultor-geia tablet-grande tablet-pequeno mb-4"
          style="background-color: #f3f3f3 0% 0% no-repeat padding-box">
          <img
            src="../../../../../assets/landing-page/img/Grupo 24.png"
            alt="Background"
            class="background-image versao-tablet" />
          <img
            src="../../../../../assets/landing-page/img/fundo-mobile.png"
            alt="Background"
            class="background-image versao-mobile" />
          <img src="../../../../../assets/landing-page/img/iris-polo.png" alt="Garota Géia" class="girl-image" />
        </section>

        <section
          class="feature-medicine-section mt-3"
          style="background-color: #fff !important; margin-top: 7rem !important">
          <div class="text-container d-flex justify-content-center align-items-center">
            <span class="subt-title-left span-30px">Quer outro tipo de seguro?</span>
            <span class="text-img span-30px">
              <i class="title-left">Conversa com a gente!</i>
            </span>
            <a [href]="whatsApp" target="_blank">
              <button
                type="button"
                class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mb-1">
                <b>FALE COM UM CONSULTOR GÉIA</b>
              </button>
            </a>
          </div>
        </section>
        <div class="carousel-inner">
          <!-- Residencial -->
          <div class="carousel-item active">
            <div class="card box-shadow-3 round w-card-seguro-mobile card-not-respo-2 tamanho-card">
              <div class="card-body">
                <h5 class="card-title title-banner title preto-geia l-s-0 title-card-seguros">
                  <b></b>
                </h5>
              </div>
              <img
                src="../../../../assets/app-assets/images/icones-geia/varejo/home.png"
                class="card-img-icon mx-auto img-top-card img-fluid img-top" />
              <div class="card-body">
                <p class="card-text text-center desc-text-card-price">
                  {{ protecaoResidencia }}
                </p>
                <h5 class="card-title text-center">
                  <b>{{ facaSuaCotacao }}</b>
                </h5>
                <div class="justify-content-center">
                  <span class="desc-price-top-seguro">{{ ApartirDe }}</span>
                  <h2 class="card-price-center">
                    17
                    <span class="cent-value">,24</span>
                  </h2>
                  <div class="text-center" style="margin-top: -18px">
                    <span class="desc-mount mb-2" style="margin-left: -16px !important">{{ parcelas }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-center div-top-card-seguro">
                  <a href="https://porto.vc/residencia_essencial_4fe5bcf84da64a009f10ddd9c72934df" target="_blank">
                    <button
                      type="button"
                      class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1">
                      <b>SIMULE E COMPRE</b>
                    </button>
                  </a>
                </div>
                <div>
                  <span class="desc-title-banner mt-1 preto-geia desc-bottom mb-2">{{ descricaoRodapeCard }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Veicular -->
          <div class="carousel-item">
            <div class="card box-shadow-3 round w-card-seguro-mobile card-not-respo-2 tamanho-card">
              <div class="card-body">
                <h5 class="card-title title-banner title preto-geia l-s-0 title-card-seguros">
                  <b></b>
                </h5>
              </div>
              <img
                src="../../../../assets/app-assets/images/icones-geia/varejo/car.png"
                class="card-img-icon mx-auto img-top-card img-fluid img-top" />
              <div class="card-body">
                <p class="card-text text-center desc-text-card-price">Aqui seu veículo está em boas mãos.</p>
                <h5 class="card-title text-center">
                  <b>{{ facaSuaCotacao }}</b>
                </h5>
                <div class="justify-content-center">
                  <span class="desc-price-top-seguro">{{ ApartirDe }}</span>
                  <h2 class="card-price-center">
                    81
                    <span class="cent-value">,46</span>
                  </h2>
                  <div class="text-center" style="margin-top: -18px">
                    <span class="desc-mount mb-2" style="margin-left: -16px !important">{{ parcelas }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-center div-top-card-seguro">
                  <a
                    href="https://wwws.portoseguro.com.br/vendaonline/home.ns?cod=29db68682e8a46bf9280fd0066523519&utm_source=49017J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CM22GJ&utm_content=GEIA_CORRETORA_DE_SEGUROS"
                    target="_blank">
                    <button
                      type="button"
                      class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1">
                      <b>SIMULE E COMPRE</b>
                    </button>
                  </a>
                </div>
                <div>
                  <span class="desc-title-banner mt-1 preto-geia desc-bottom mb-2">{{ descricaoRodapeCard }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Vida -->
          <div class="carousel-item">
            <div class="card box-shadow-3 round w-card-seguro-mobile card-not-respo-2 tamanho-card">
              <div class="card-body">
                <h5 class="card-title title-banner title preto-geia l-s-0 title-card-seguros">
                  <b></b>
                </h5>
              </div>
              <img
                src="../../../../assets/app-assets/images/icones-geia/varejo/coracao.png"
                class="card-img-icon mx-auto img-top-card img-fluid img-top"
                style="margin-bottom: 15px" />
              <div class="card-body">
                <p class="card-text text-center desc-text-card-price">Aproveite cada momento com toda segurança.</p>
                <h5 class="card-title text-center">
                  <b>{{ facaSuaCotacao }}</b>
                </h5>
                <div class="justify-content-center">
                  <span class="desc-price-top-seguro">{{ ApartirDe }}</span>
                  <h2 class="card-price-center">
                    11
                    <span class="cent-value">,98</span>
                  </h2>
                  <div class="text-center" style="margin-top: -18px">
                    <span class="desc-mount mb-2" style="margin-left: -16px !important">{{ parcelas }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-center div-top-card-seguro">
                  <a
                    href="https://wwws.portoseguro.com.br/vendaonline/vidamaissimples/home.ns?cod=a8392b88d7ba4ea7a7494acb79082a60&utm_campaign=GeradordeLinks_CM22GJ&utm_content=GEIA_CORRETORA_DE_SEGUROS&origem="
                    target="_blank">
                    <button
                      type="button"
                      class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1">
                      <b>SIMULE E COMPRE</b>
                    </button>
                  </a>
                </div>
                <div>
                  <span class="desc-title-banner mt-1 preto-geia desc-bottom mb-2">{{ descricaoRodapeCard }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>

      <!--  versao tablet -->

      <div class="responsive-block versao-tablet">
        <!-- Fale com um consultor Géia -->
        <section
          class="banner-container fale-consultor-geia tablet-grande tablet-pequeno mb-4"
          style="background-color: #f3f3f3 0% 0% no-repeat padding-box">
          <img
            src="../../../../../assets/landing-page/img/Grupo 24.png"
            alt="Background"
            class="background-image versao-tablet" />
          <img
            src="../../../../../assets/landing-page/img/fundo-mobile.png"
            alt="Background"
            class="background-image versao-mobile" />
          <img src="../../../../../assets/landing-page/img/iris-polo.png" alt="Garota Géia" class="girl-image" />
          <div class="text-container d-flex justify-content-center align-items-center versao-tablet">
            <span class="subt-title-left span-30px">Quer outro tipo de seguro?</span>
            <span class="text-img span-30px">
              <i class="title-left">Conversa com a gente!</i>
            </span>
            <a [href]="whatsApp" target="_blank">
              <button
                type="button"
                class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mb-1">
                <b>FALE COM UM CONSULTOR GÉIA</b>
              </button>
            </a>
          </div>
        </section>
        <!-- Residencial -->
        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
          <div class="card box-shadow-3 round w-card-seguro-mobile card-not-respo-2">
            <div class="card-body">
              <h5 class="card-title title-banner title preto-geia l-s-0 title-card-seguros">
                <b></b>
              </h5>
            </div>
            <img
              src="../../../../assets/app-assets/images/icones-geia/varejo/home.png"
              class="card-img-icon mx-auto img-top-card img-fluid img-top" />

            <div class="card-body">
              <p class="card-text text-center desc-text-card-price">
                {{ protecaoResidencia }}
              </p>
              <h5 class="card-title text-center">
                <b>{{ facaSuaCotacao }}</b>
              </h5>

              <div class="justify-content-center">
                <span class="desc-price-top-seguro">{{ ApartirDe }}</span>
                <h2 class="card-price-center">
                  17
                  <span class="cent-value">,24</span>
                </h2>
                <div class="text-center" style="margin-top: -18px">
                  <span class="desc-mount mb-2" style="margin-left: -16px !important">em 12 parcelas</span>
                </div>
              </div>

              <div class="d-flex justify-content-center div-top-card-seguro">
                <a href="https://porto.vc/residencia_essencial_4fe5bcf84da64a009f10ddd9c72934df" target="_blank">
                  <button
                    type="button"
                    class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1">
                    <b>SIMULE E COMPRE</b>
                  </button>
                </a>
              </div>

              <div>
                <span class="desc-title-banner mt-1 preto-geia desc-bottom mb-2">{{ descricaoRodapeCard }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Veicular -->
        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
          <div class="card box-shadow-3 round w-card-seguro-mobile card-not-respo-2">
            <!-- margin-top: -234px!important; -->
            <div class="card-body">
              <h5 class="card-title title-banner title preto-geia l-s-0 title-card-seguros">
                <b></b>
              </h5>
            </div>
            <img
              src="../../../../assets/app-assets/images/icones-geia/varejo/car.png"
              class="card-img-icon mx-auto img-top-card img-fluid img-top" />

            <div class="card-body">
              <p class="card-text text-center desc-text-card-price">Aqui seu veículo está em boas mãos.</p>
              <h5 class="card-title text-center">
                <b>{{ facaSuaCotacao }}</b>
              </h5>

              <div class="justify-content-center">
                <span class="desc-price-top-seguro">{{ ApartirDe }}</span>
                <h2 class="card-price-center">
                  81
                  <span class="cent-value">,46</span>
                </h2>
                <div class="text-center" style="margin-top: -18px">
                  <span class="desc-mount mb-2" style="margin-left: -16px !important">em 12 parcelas</span>
                </div>
              </div>

              <div class="d-flex justify-content-center div-top-card-seguro">
                <a
                  href="https://wwws.portoseguro.com.br/vendaonline/home.ns?cod=29db68682e8a46bf9280fd0066523519&utm_source=49017J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CM22GJ&utm_content=GEIA_CORRETORA_DE_SEGUROS"
                  target="_blank">
                  <button
                    type="button"
                    class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1">
                    <b>SIMULE E COMPRE</b>
                  </button>
                </a>
              </div>

              <div>
                <span class="desc-title-banner mt-1 preto-geia desc-bottom mb-2">{{ descricaoRodapeCard }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Vida -->
        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
          <div class="card box-shadow-3 round w-card-seguro-mobile card-not-respo-2">
            <!-- margin-top: -234px!important; -->
            <div class="card-body">
              <h5 class="card-title title-banner title preto-geia l-s-0 title-card-seguros">
                <b></b>
              </h5>
            </div>
            <img
              src="../../../../assets/app-assets/images/icones-geia/varejo/coracao.png"
              class="card-img-icon mx-auto img-top-card img-fluid img-top"
              style="margin-bottom: 28px" />

            <div class="card-body">
              <p class="card-text text-center desc-text-card-price">Aproveite cada momento com toda segurança.</p>
              <h5 class="card-title text-center">
                <b>{{ facaSuaCotacao }}</b>
              </h5>

              <div class="justify-content-center">
                <span class="desc-price-top-seguro">{{ ApartirDe }}</span>
                <h2 class="card-price-center">
                  11
                  <span class="cent-value">,98</span>
                </h2>
                <div class="text-center" style="margin-top: -18px">
                  <span class="desc-mount mb-2" style="margin-left: -16px !important">em 12 parcelas</span>
                </div>
              </div>

              <div class="d-flex justify-content-center div-top-card-seguro">
                <a
                  href="https://wwws.portoseguro.com.br/vendaonline/vidamaissimples/home.ns?cod=a8392b88d7ba4ea7a7494acb79082a60&utm_campaign=GeradordeLinks_CM22GJ&utm_content=GEIA_CORRETORA_DE_SEGUROS&origem="
                  target="_blank">
                  <button
                    type="button"
                    class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1">
                    <b>SIMULE E COMPRE</b>
                  </button>
                </a>
              </div>

              <div>
                <span class="desc-title-banner mt-1 preto-geia desc-bottom mb-2">{{ descricaoRodapeCard }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fale conosco -->
      <div class="row align-items-center">
        <div class="col-12">
          <div class="section-heading heading-white">
            <div class="section-heading">
              <span class="subt-title-left span-30px">Atendimento</span>
              <h3 class="title-left" style="line-height: 1.1">Personalizado</h3>
            </div>
            <span
              class="subt-title-left span-28px full-width-text"
              style="line-height: 1.4 !important; font-weight: 600 !important; font-size: 15px !important">
              Nosso time técnico está à disposiçào durante o ano todo para dirimir quaisquer dúvidas e atuar como
              facilitadores entre as mais diversas companhias
              <b>Seguradoras e Resseguradoras</b>
              , proporcionando as melhores soluções em seguros corporativos para nossos Clientes.
            </span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-10">
          <div class="feature-content pr-xl-5 mt-md-50">
            <div class="section-heading text-center heading-white container">
              <h2 class="title-left text-rigth mb-1" style="font-size: 24px !important">FALE CONOSCO!</h2>
            </div>
            <form [formGroup]="formGroupEmailContact" (ngSubmit)="onSubmit()" class="form row">
              <div class="form-group col-md-12 mb-2">
                <fieldset class="form-group position-relative has-icon-left">
                  <input
                    required
                    name="nome"
                    type="text"
                    id="name"
                    maxlength="50"
                    formControlName="name"
                    [ngClass]="{
                      'is-invalid': formGroupEmailContact.controls['name'].errors && formSubmitted
                    }"
                    placeholder="Informe seu nome"
                    class="form-control border-radius ng-dirty ng-valid ng-touched" />
                  <div class="form-control-position mr-t-icon">
                    <i class="fa fa-user"></i>
                  </div>
                  <div
                    *ngIf="formGroupEmailContact.controls['name'].errors?.['required'] && formSubmitted"
                    class="invalid-feedback">
                    Campo obrigatório
                  </div>
                </fieldset>
              </div>

              <div class="form-group col-md-6 mb-2">
                <fieldset class="form-group position-relative has-icon-left">
                  <input
                    name="celular"
                    type="tel"
                    id="celular"
                    mask="(00) 00000-0000"
                    [showMaskTyped]="true"
                    formControlName="phone"
                    placeholder="Informe o Celular"
                    [ngClass]="{
                      'is-invalid': formGroupEmailContact.controls['phone'].errors && formSubmitted
                    }"
                    class="form-control border-radius ng-dirty ng-valid ng-touched" />
                  <div class="form-control-position mr-t-icon">
                    <i class="fa fa-phone"></i>
                  </div>
                </fieldset>
              </div>
              <div class="form-group col-md-6 mb-2">
                <fieldset class="form-group position-relative has-icon-left">
                  <input
                    name="email"
                    type="text"
                    id="user-email"
                    maxlength="60"
                    formControlName="email"
                    [ngClass]="{
                      'is-invalid': formGroupEmailContact.controls['email'].errors && formSubmitted
                    }"
                    placeholder="Informe o E-mail"
                    class="form-control border-radius ng-dirty ng-valid ng-touched" />
                  <div class="form-control-position mr-t-icon">
                    <i class="fa fa-envelope-o"></i>
                  </div>
                  <div
                    *ngIf="formGroupEmailContact.controls['email'].errors?.['required'] && formSubmitted"
                    class="invalid-feedback">
                    Campo obrigatório
                  </div>
                  <div
                    *ngIf="formGroupEmailContact.controls['email'].errors?.['pattern'] && formSubmitted"
                    class="invalid-feedback">
                    E-mail Inválido
                  </div>
                </fieldset>
              </div>
              <div class="form-group col-md-12 mb-2">
                <textarea
                  rows="7"
                  class="form-control border-radius"
                  name="message"
                  formControlName="message"
                  placeholder="Insira o texto aqui..."
                  [ngClass]="{
                    'is-invalid': formGroupEmailContact.controls['message'].errors && formSubmitted
                  }"></textarea>
                <div
                  *ngIf="formGroupEmailContact.controls['message'].errors?.['required'] && formSubmitted"
                  class="invalid-feedback">
                  Campo obrigatório
                </div>
              </div>
              <div class="form-group col-12 mb-2">
                <app-captcha #captcha (tokenChange)="captchaToken = $event"></app-captcha>
              </div>
              <div class="form-group col-12 mb-2">
                <div class="float-right">
                  <button
                    [disabled]="!isSendEmail"
                    class="btn btn-round btn-geia-info bold-azul bold-azul-geia btn-outline-info btn-min-width box-shadow-4 mr-1 mb-1 btn-block">
                    ENVIAR
                    <i
                      class="bold-azul-geia mr-1"
                      [ngClass]="isLoading ? 'fa fa fa-refresh fa-spin  fa-fw' : 'fa fa-arrow-right  '"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="rodape"></div>
      </div>
    </div>
  </section>
  <app-portal-footer></app-portal-footer>
</div>
